import React from "react";
import { useNavigate } from "react-router-dom";
import { UserRound } from "lucide-react";
import ROUTES from "../../router/routes";
import UserAuthStore from "../../store/userStore";

const UserDropdown = () => {
  const navigate = useNavigate();
  const user = UserAuthStore((state) => state.user);

  return (
    <div className="relative bg-gradient-to-r from-gradient-gradient-primary to-gradient-accent rounded-full p-[1px]">
      <button
        type="button"
        onClick={() => navigate(ROUTES.SETTINGS.PROFILE)}
        className="photon-avatar flex items-center justify-center w-9 h-9 rounded-full border-[0.5px] border-transparent transition-colors duration-200 overflow-hidden"
        aria-label="Open profile settings"
        title="Profile settings"
      >
        {user?.photoURL ? (
          <img src={user.photoURL} alt="User Avatar" className="w-full h-full object-cover" />
        ) : (
          <UserRound size={22} className="shrink-0" aria-hidden="true" />
        )}
      </button>
    </div>
  );
};

export default UserDropdown;
